<template>
  <v-tooltip
    top
    max-width="300px"
  >
    <template #activator="{ on, attrs }">
      <span
        class="small"
        :class="leftSpace ? 'ml-2' : ''"
        v-bind="attrs"
        v-on="on"
      >
        <i :class="icon" />
      </span>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    tooltipText: {
      type: String,
      required: false,
      default: 'Info'
    },
    icon: {
      type: String,
      default: 'fas fa-question-circle'
    },
    leftSpace: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style scoped>
  span i {
    color: #70697a!important;
    font-size: 12px!important;
  }
</style>
